import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translation from 'shared/translation/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      lookupLocalStorage: 'locale',
      order: ['navigator', 'localStorage'],
    },
    keySeparator: true,
    resources: translation,
  });

export default i18n;
